import { Validators } from "@angular/forms";
import {
  FieldConfig,
  FieldType
} from "../../../../../../shared/components/dynamic-forms-components/field.interface";
import { SensorType } from "../../../../../../store/entities/warehouse-management/device/device.model";
import { of } from "rxjs";
const sensorType = of([
  { id: 1, name: 'TEMPERATURE', value: "TEMPERATURE" },
  { id: 2, name: 'HUMIDITY', value: "HUMIDITY" },
  { id: 3, name: 'BOTH', value: "BOTH" },
])

export const sensorFields: FieldConfig[] = [

  {
    type: FieldType.input,
    label: 'serialNumber',
    key: 'serialNumber',
    validations: [{ message: 'This field is Required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-12'
  },
  {
    type: FieldType.input,
    label: 'Name',
    key: 'sensorName',
    validations: [{ message: 'This field is Required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-12'
  },
  {
    type: FieldType.input,
    label: 'Ip Address',
    key: 'sensorIp',
    validations: [{ message: 'This field is Required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-12'
  },
    {
    type: FieldType.input,
    inputType:'number',
    label: 'Data send interval in minutes',
    key: 'dataSendIntervalMinutes',
    validations: [{ message: 'This field is Required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-12'
  },
  {
    type: FieldType.input,
    label: 'Sensor Location',
    key: 'sensorLocation',
    validations: [{ message: 'This field is Required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-12'
  },
  {
    type: FieldType.checkbox,
    label: 'Is Cold Room Sensor',
    key: 'isColdRoomSensor',
    rowClass: 'col-span-12'
  },
  {
    type: FieldType.select,
    options: sensorType,
    label: 'sensorType',
    key: 'sensorType',
    validations: [{ message: 'This field is Required', validator: Validators.required, name: 'required' }],
    rowClass: 'col-span-12'
  },
  {
    type: FieldType.attachment,
    fileType: "LOGO",
    label: 'Device Picture',
    key: 'posPicture',
    acceptType: ['.png', '.jpg', '.jpeg'],
    rowClass: 'col-span-12',
  },

  {
    type: FieldType.button,
    label: 'Save',
    rowClass: 'col-span-12'
  },
];
